export const FONT_FAMILY = 'ProximaNova'
